import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { DeleteFollowupDraftMessageDocument } from '~/graphql/generated/graphql';
import { patientDetailDialogMessageState } from '~/state/partials/patient_detail_dialog/atoms';

export const useDeleteDraftMessage = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const setPatientDetailDialogMessageState = useSetAtom(patientDetailDialogMessageState);
  const [deleteDraftMessage, { data }] = useMutation(DeleteFollowupDraftMessageDocument);

  useEffect(() => {
    if (!data?.deleteMedicationFollowupDraftMessage) return;

    setPatientDetailDialogMessageState((state) => ({
      ...state,
      draftMessageId: null,
    }));
  }, [data, setPatientDetailDialogMessageState]);

  const deleteDraft = useCallback(
    async (medicationFollowupDraftMessageId: string) => {
      setIsDeleting(true);
      setError(null);

      try {
        await deleteDraftMessage({
          variables: {
            input: {
              medicationFollowupDraftMessageId,
            },
          },
        });
        setIsDeleting(false);
      } catch (_error) {
        setError(_error?.message || 'エラーが発生しました');
        setIsDeleting(false);
        throw new Error('', { cause: _error });
      }
    },
    [deleteDraftMessage],
  );

  return {
    deleting: isDeleting,
    error,
    deleteDraft,
  };
};
